import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { MasterService } from '../../../@core/services/master.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'ngx-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit{
  form: FormGroup;
  currentPage: number = 1;
  itemsPerPage: number = 10;
  paginateData: any;
  firstItemIndex: number = 1;
  lastItemIndex: number = 0;
  tableDataLength: number = 0;
  paginationData: any;
  searchInput: any = '';
  // selectedCustomerName: any = "";
  selectedEngineer: any = "";
  selectedCurrentStage: any = "";
  selectedRfqDate: any = "";
  selectedExpetedCompletionDate: any = "";
  matchedCustomerData: any[] = []; // To store the matching result
  modalRef: NgbModalRef | null = null;
  selectedCustomerName: string = '';
  searchText: string = '';
  showAddCustomerButton: boolean = false;
  sourcingListFiles: File[] = [];
  alternatePartFiles: File[] = [];
  finalDataList = [];
  fromExpectedCompletionDate: string = '';
toExpectedCompletionDate: string = '';

fromRfqDate: string = '';
toRfqDate: string = '';
 showModalECD: boolean = false; // ECD modal visibility flag
  showModalRFQ: boolean = false;
  // allCustomerData = [
  //   {
  //     serialNumber: 100001,
  //     customerName: "John Doe",
  //     city: "New York",
  //     state: "NY",
  //     country: "USA",
  //     gstNumber: "GST12345",
  //     createdBy: "Admin",
  //     createdOn: "2024-10-01",
  //     lastModifiedBy: "Admin",
  //     lastModifiedOn: "2024-11-01",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100002,
  //     customerName: "Jane Smith",
  //     city: "Los Angeles",
  //     state: "CA",
  //     country: "USA",
  //     gstNumber: "GST67890",
  //     createdBy: "Manager",
  //     createdOn: "2024-09-15",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-10-20",
  //     activeStatus: false,
  //   },
  //   {
  //     serialNumber: 100003,
  //     customerName: "Michael Johnson",
  //     city: "Chicago",
  //     state: "IL",
  //     country: "USA",
  //     gstNumber: "GST24680",
  //     createdBy: "Staff",
  //     createdOn: "2024-08-10",
  //     lastModifiedBy: "Admin",
  //     lastModifiedOn: "2024-09-05",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100004,
  //     customerName: "Emily Davis",
  //     city: "Houston",
  //     state: "TX",
  //     country: "USA",
  //     gstNumber: "GST13579",
  //     createdBy: "Admin",
  //     createdOn: "2024-07-20",
  //     lastModifiedBy: "Manager",
  //     lastModifiedOn: "2024-09-25",
  //     activeStatus: false,
  //   },
  //   {
  //     serialNumber: 100005,
  //     customerName: "Chris Wilson",
  //     city: "Phoenix",
  //     state: "AZ",
  //     country: "USA",
  //     gstNumber: "GST98765",
  //     createdBy: "Manager",
  //     createdOn: "2024-11-10",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-11-12",
  //     activeStatus: true,
  //   },
  //   {
  //     serialNumber: 100006,
  //     customerName: "Chris Wilson",
  //     city: "Phoenix",
  //     state: "AZ",
  //     country: "USA",
  //     gstNumber: "GST98765",
  //     createdBy: "Manager",
  //     createdOn: "2024-11-10",
  //     lastModifiedBy: "Supervisor",
  //     lastModifiedOn: "2024-11-12",
  //     activeStatus: false,
  //   },
  // ];
  allCustomerData = [];
  // allCustomerData = [
  //   {
  //     serialNumber: 1,
  //     projectName: "Project Alpha",
  //     customerName: "Customer A",
  //     rfqDate: new Date("2024-01-15"),
  //     assignedTo: "John Doe",
  //     assignedDate: new Date("2024-01-20"),
  //     expetedCompletionDate: new Date("2024-02-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "50%",
  //     status: "Open-New",
  //     currentStage: "Stage 2",
  //     activeStatus: true,
  //     version_id: 'Version 1'
  //   },
  //   {
  //     serialNumber: 2,
  //     projectName: "Project Beta",
  //     customerName: "Customer B",
  //     rfqDate: new Date("2024-02-01"),
  //     assignedTo: "Jane Smith",
  //     assignedDate: new Date("2024-02-05"),
  //     expetedCompletionDate: new Date("2024-03-01"),
  //     targetLeadTime: "3 weeks",
  //     ageing: "1 week",
  //     progress: "30%",
  //     status: "Open-In Progress",
  //     currentStage: "Stage 1",
  //     activeStatus: false,
  //     version_id: 'Version 1'
  //   },
  //   {
  //     serialNumber: 3,
  //     projectName: "Project Gamma",
  //     customerName: "Customer C",
  //     rfqDate: new Date("2024-01-10"),
  //     assignedTo: "Alice Johnson",
  //     assignedDate: new Date("2024-01-12"),
  //     expetedCompletionDate: new Date("2024-02-10"),
  //     targetLeadTime: "6 weeks",
  //     ageing: "4 weeks",
  //     progress: "70%",
  //     status: "Closed",
  //     currentStage: "Costing",
  //     activeStatus: true,
  //     version_id: 'Version 1'
  //   },
  //   {
  //     serialNumber: 4,
  //     projectName: "Project Delta",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-01-25"),
  //     assignedTo: "Bob Williams",
  //     assignedDate: new Date("2024-01-30"),
  //     expetedCompletionDate: new Date("2024-03-05"),
  //     targetLeadTime: "5 weeks",
  //     ageing: "3 weeks",
  //     progress: "40%",
  //     status: "Open-In Progress",
  //     currentStage: "Stage 2",
  //     activeStatus: false,
  //     version_id: 'Version 1'
  //   },
  //   {
  //     serialNumber: 5,
  //     projectName: "Project Epsilon",
  //     customerName: "Customer E",
  //     rfqDate: new Date("2024-02-10"),
  //     assignedTo: "Chris Brown",
  //     assignedDate: new Date("2024-02-15"),
  //     expetedCompletionDate: new Date("2024-03-15"),
  //     targetLeadTime: "4 weeks",
  //     ageing: "2 weeks",
  //     progress: "20%",
  //     status: "Open-Over Due",
  //     currentStage: "Stage 1",
  //     activeStatus: true,
  //     version_id: 'Version 1'
  //   }
  // ];
  versions = [1, 2, 3, 4];
  // pageSize: number;
  addtionalChargesDetails = [];
  downloadData = [];
  closeResult: string;
  incorUploadFiles: any[];
  selectedIncorFile: any;
  data: unknown[];
  dataProp: string[];
  sourceListData: any[];
  avdData = [];
  sourcingListFileName: string = '';
  upload_input: any;
  avdListFileName: string = '';
  upload_avd_input: any;
  userId: number;
  openStatusCount: number;
  overdueCount : number
  allCustomerDetails = [];

  constructor(private f_builder: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private notify: NbToastrService,
    private masterService: MasterService,
    private datePipe: DatePipe,
  ) { }


  ngOnInit(): void {
    this.userId = Number(sessionStorage.getItem('user_id'));
    this.form = this.f_builder.group({
      source_file_name: [''],
      sourcingListFileName: [''],
      alternatePartFileName: [''],

    });
    // this.matchedCustomerData = this.allCustomerData;
    this.getAllAsignedEngineer();
    this.getAllcustomers();
  }

  resetFields() {
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    this.selectedRfqDate = '';
    // this.editProjectRow(null);
    // this.getAllProjectData();

    this.getAllAsignedEngineer();
    this.getAllcustomers();
  }

  getAllcustomers() {
   
    let cus = {
      "operation_type": "READALL"
    }
    this.masterService.all_customers(cus).subscribe((result: any) => {
      let message = result['message'];
      let status = result['status'];
      if (result) {
        // this.engineersData = result['data'];
        this.allCustomerData = result;
        console.log('allCustomerData', this.allCustomerData);
      } else {
        // Handle error if status is not true
        console.error('Error: Unable to retrieve project data');
        // You can also set an error message to display in the UI
        // alert('There was an issue retrieving the project data. Please try again.');
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }

    })
  }

  getAllAsignedEngineer() {
    let payloadData = {
      "action": "SELECT_BY_ASSIGNED_USERID",
      "assigned_to_id": this.userId
    }
    this.masterService.manage_projects(payloadData).subscribe((result: any) => {
      let message = result['message'];
      let status = result['status'];
      if (result) {
        // this.engineersData = result['data'];
        let data = result['data'];
        // this.sortDataDescending(data);
        // this.projectsData = result['data'];
          data.sort((a: any, b: any) => {
      return new Date(b.assigned_date).getTime() - new Date(a.assigned_date).getTime();
    });

        this.allCustomerDetails = data;
        this.matchedCustomerData = data;
        console.log('matchedCustomerData', this.matchedCustomerData);
        // Count the number of rows with status === 'Open'
        const openStatusCount = this.matchedCustomerData.filter(customer => customer.status === 'Open' || customer.status === 'In Progress').length;
        // Store it in a variable
        this.openStatusCount = openStatusCount;
        console.log('Number of rows with status "Open":', this.openStatusCount);
        
        // over due count 
        // const overdueCount = this.matchedCustomerData.filter(customer => customer.status === 'Open' || customer.status === 'In Progress').length;
        // Store it in a variable

        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time to midnight
    
        console.log('Today:', today);
    
        let overdueCount = this.matchedCustomerData.filter(item => {
            const expectedDate = new Date(item.expectedCompletionDate);
            expectedDate.setHours(0, 0, 0, 0); // Reset expected date to midnight
            return expectedDate < today; // Compare dates
        }).length;

        this.overdueCount = overdueCount;

        console.log('Number of overdue count :', this.overdueCount);

        
        // Set the latest version_id as the default
        this.matchedCustomerData = this.matchedCustomerData.map((customer1: any) => {
          return { ...customer1, version_id: customer1.version_id || this.versions[this.versions.length - 1] };
        });
      
      } else {
        // Handle error if status is not true
        console.error('Error: Unable to retrieve project data');
        // You can also set an error message to display in the UI
        // alert('There was an issue retrieving the project data. Please try again.');
        this.notify.danger('There was an issue retrieving the project data. Please try again.');
      }

    })
  }
  // Handle version_id change
  onVersionChange(customer: any) {
    console.log('Selected version_id for customer:', customer.version_id, this.matchedCustomerData);
    // Perform any additional processing, like updating data in the backend

    const customerIndex = this.matchedCustomerData.findIndex(c => c.project_id === customer.project_id);
    
    if (customerIndex !== -1) {
      // Update only the version_id for the specific row (matching the project_id)
      this.matchedCustomerData[customerIndex].version_id = Number(customer.version_id);
      
      // Log to check if the version_id is correctly updated
      console.log('Updated version_id for project:', this.matchedCustomerData[customerIndex].version_id);
      
      // Update the selected version id
      let selectedVersionId = Number(customer.version_id);
      let selectedRowProjectId = Number(customer.project_id);

      let payloadData = {
        "action": "SELECT_PROJECTS",
        "assigned_to_id": Number(this.userId),
        "project_id": selectedRowProjectId,
        "version_id": selectedVersionId
      }
      this.masterService.manage_projects(payloadData).subscribe((result: any) => {
        let message = result['message'];
        let status = result['status'];

        console.log('res in project', result)

        if(result){
          let data = result['data'];
          console.log('data', data)
        
          console.log('this.matchedCustomerData', this.matchedCustomerData);

        // Find the object in result.data that matches project_id & version_id

        let matchingData = data.find(
          (dataItem: any) =>
            dataItem.project_id === selectedRowProjectId &&
            dataItem.version_id === selectedVersionId
        );

        if (matchingData) {
          let isUpdated = false;

          let sortedMatchingData = { 
            ...matchingData, 
            version_ids: [...matchingData.version_ids].sort((a, b) => a - b) 
          };


          this.matchedCustomerData.forEach((item, index) => {
            if (item.project_id === selectedRowProjectId && item.version_id === selectedVersionId) {
              isUpdated = true;

              // ✅ Update the object reference to trigger change detection
              this.matchedCustomerData[index] = { ...item, ...sortedMatchingData };
            }
          });

          console.log('this.matchedCustomerData after update:', this.matchedCustomerData);

          if (!isUpdated) {
            this.notify.danger('Data not found');
          } else {
            // this.projectRowDetailsWithVersionId = matchingData;

            // ✅ Force change detection if UI is not updating
            this.matchedCustomerData = [...this.matchedCustomerData]; 
            // this.paginatedData = [...this.matchedCustomerData]; 

          }
        } else {
          this.notify.danger('Data not found in response');
        }

        }
          else {
            // Handle error if status is not true
            console.error('Error: Unable to retrieve project data');
            this.notify.danger('There was an issue retrieving the project data. Please try again.');
          }
        
      });

    }

  }

  onOpenClickedProject(status : string){
    console.log('openStatusCount', this.openStatusCount, status)
    console.log('this.matchedCustomerData', this.matchedCustomerData);

    let data = this.matchedCustomerData.filter(customer => customer.status === status);

    this.matchedCustomerData = [...data]

    console.log('Matched Customer Data:', this.matchedCustomerData);
    // this.updateTableRows();

    
  }

  onOverdueClick() {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to midnight

    console.log('Today:', today);

    let filterdata = this.matchedCustomerData.filter(item => {
        const expectedDate = new Date(item.expectedCompletionDate);
        expectedDate.setHours(0, 0, 0, 0); // Reset expected date to midnight

        // console.log('Expected Completion Date:', expectedDate);

        return expectedDate > today; // Compare dates
    });

    this.matchedCustomerData = [...filterdata]

    // this.updateTableRows();
    console.log('Filtered Overdue Data:', filterdata);
}



  onSelectCustomer() {
    
    // this.selectedEngineer = '';
    // this.selectedCurrentStage = '';
    // this.selectedExpetedCompletionDate = '';
    console.log('Selected Customer:', this.selectedCustomerName);
    this.matchedCustomerData = this.allCustomerDetails
      .filter(cus => cus.customer_name === this.selectedCustomerName)
      .map(cus => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        project_id: cus.project_id,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_date: cus.assigned_date,
        assigned_to_name: cus.assigned_to_name,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
    console.log('matched CustomerData', this.matchedCustomerData)
    // Set the latest version_id as the default
    this.matchedCustomerData = this.matchedCustomerData.map((customer1: any) => {
      return { ...customer1, version_id: customer1.version_id || this.versions[this.versions.length - 1] };
    });
  }

  onSelectEnginner() {
    this.matchedCustomerData = this.allCustomerDetails
      .filter(cus => Number(cus.assigned_to_id) === Number(this.selectedEngineer))
      .map(cus => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_date: cus.assigned_date,
        assigned_to_name: cus.assigned_to_name,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
    // Set the latest version_id as the default
    this.matchedCustomerData = this.matchedCustomerData.map((customer1: any) => {
      return { ...customer1, version_id: customer1.version_id || this.versions[this.versions.length - 1] };
    });
  }
  
  onSelectStage(eve: any) {
   
    // console.log('eve', eve);
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedExpetedCompletionDate = '';
    let selectedStage = eve.target.value
    console.log('val', selectedStage);
   
    this.matchedCustomerData = this.allCustomerDetails
      .filter(cus => cus.currentstage === this.selectedCurrentStage)
      .map(cus => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_to_name: cus.assigned_to_name,
        assigned_date: cus.assigned_date,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
    // Set the latest version_id as the default
    this.matchedCustomerData = this.matchedCustomerData.map((customer1: any) => {
      return { ...customer1, version_id: customer1.version_id || this.versions[this.versions.length - 1] };
    });
  }
  onSelectCompletionDate() {
    
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedRfqDate = '';
    console.log('Selected Expected Completion Date:', this.selectedExpetedCompletionDate);
    // Add any additional logic here when the date changes
    this.matchedCustomerData = this.allCustomerDetails
      .filter(cus => cus.expectedCompletionDate === this.selectedExpetedCompletionDate)
      .map(cus => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_date: cus.assigned_date,
        assigned_to_name: cus.assigned_to_name,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
    // Set the latest version_id as the default
    this.matchedCustomerData = this.matchedCustomerData.map((customer1: any) => {
      return { ...customer1, version_id: customer1.version_id || this.versions[this.versions.length - 1] };
    });
      this.applyDateFilters();
  }
   resetDates() {
    this.fromExpectedCompletionDate = null;
    this.toExpectedCompletionDate = null;
  }
  resetRfqDates() {
    this.fromRfqDate = null;
    this.toRfqDate = null;
  }
   // Open ECD Modal
  openModalECD() {
    this.showModalECD = true;
  }

  // Close ECD Modal
  closeModalECD() {
    this.showModalECD = false;
  }

  // Open RFQ Modal
  openModalRFQ() {
    this.showModalRFQ = true;
  }

  // Close RFQ Modal
  closeModalRFQ() {
    this.showModalRFQ = false;
  }

  onDateRangeChange() {
   
    this.selectedCustomerName = '';
    this.selectedEngineer = '';
    this.selectedCurrentStage = '';
    this.selectedExpetedCompletionDate = '';
    console.log('Selected RFQ Date:', this.selectedRfqDate);
    // Add any logic you need when the date changes
    this.matchedCustomerData = this.allCustomerDetails
      .filter(cus => cus.rfqDate === this.selectedRfqDate)
      .map(cus => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_date: cus.assigned_date,
        assigned_to_name: cus.assigned_to_name,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));

    // Set the latest version_id as the default
    this.matchedCustomerData = this.matchedCustomerData.map((customer1: any) => {
      return { ...customer1, version_id: customer1.version_id || this.versions[this.versions.length - 1] };
    });
      this.applyDateFilters();
  }
// Main filtering method
applyDateFilters() {
  this.selectedCustomerName = '';
  this.selectedEngineer = '';
  this.selectedCurrentStage = '';
  this.selectedExpetedCompletionDate = '';
  this.selectedRfqDate = '';

  this.matchedCustomerData = this.allCustomerDetails.filter(cus => {
    const ecdDate = cus.expectedCompletionDate ? new Date(cus.expectedCompletionDate) : null;
    const rfqDate = cus.rfqDate ? new Date(cus.rfqDate) : null;

    const fromECD = this.fromExpectedCompletionDate ? new Date(this.fromExpectedCompletionDate) : null;
    const toECD = this.toExpectedCompletionDate ? new Date(this.toExpectedCompletionDate) : null;

    const fromRFQ = this.fromRfqDate ? new Date(this.fromRfqDate) : null;
    const toRFQ = this.toRfqDate ? new Date(this.toRfqDate) : null;

    const ecdMatch =
      (!fromECD || (ecdDate && ecdDate >= fromECD)) &&
      (!toECD || (ecdDate && ecdDate <= toECD));

    const rfqMatch =
      (!fromRFQ || (rfqDate && rfqDate >= fromRFQ)) &&
      (!toRFQ || (rfqDate && rfqDate <= toRFQ));

    return ecdMatch && rfqMatch;
  }).map(cus => ({
    serialNumber: cus.serialNumber,
    rfqDate: cus.rfqDate,
    expectedCompletionDate: cus.expectedCompletionDate,
    projectName: cus.projectName,
    targetLeadTime: cus.targetLeadTime,
    created_by_id: cus.created_by_id,
    created_date: cus.created_date,
    assigned_to_id: cus.assigned_to_id,
    assigned_date: cus.assigned_date,
    assigned_to_name: cus.assigned_to_name,
    customer_id: cus.customer_id,
    ageing: cus.ageing,
    progress: cus.progress,
    status: cus.status,
    currentstage: cus.currentstage,
    activestatus: cus.activestatus,
    customer_name: cus.customer_name,
    version_id: cus.version_id || this.versions[this.versions.length - 1]
  }));
}

  onSelectMonthRfq() {
    this.matchedCustomerData = this.allCustomerDetails
      .filter(cus => cus.customerName === this.selectedCustomerName)
      .map(cus => ({
        serialNumber: cus.serialNumber,
        rfqDate: cus.rfqDate,
        expectedCompletionDate: cus.expectedCompletionDate,
        projectName: cus.projectName,
        targetLeadTime: cus.targetLeadTime,
        created_by_id: cus.created_by_id,
        created_date: cus.created_date,
        assigned_to_id: cus.assigned_to_id,
        assigned_date: cus.assigned_date,
        assigned_to_name: cus.assigned_to_name,
        customer_id: cus.customer_id,
        ageing: cus.ageing,
        progress: cus.progress,
        status: cus.status,
        currentstage: cus.currentstage,
        activestatus: cus.activestatus,
        customer_name: cus.customer_name
      }));
    // Set the latest version_id as the default
    this.matchedCustomerData = this.matchedCustomerData.map((customer1: any) => {
      return { ...customer1, version_id: customer1.version_id || this.versions[this.versions.length - 1] };
    });
  }

  activeTab: number = 1; // Track the active tab

  // Sample data for each table
  tableData1 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' },
    { column1: 'Row 2, Col 1', column2: 'Row 2, Col 2', column3: 'Row 2, Col 3' }
  ];
  tableData2 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];
  tableData3 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];
  tableData4 = [
    { column1: 'Row 1, Col 1', column2: 'Row 1, Col 2', column3: 'Row 1, Col 3' }
  ];

  // Method to set the active tab
  setActiveTab(tabNumber: number): void {
    this.activeTab = tabNumber;
  }

  back() {
    this.router.navigate(['/master/additional-charges/table']);
  }

 

  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openCustomerModel(customerModal) {
    this.modalRef = this.modalService.open(customerModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  openProjectModel(projectModal) {
    this.modalRef = this.modalService.open(projectModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  onLandinCost(landinCostModal) {
    this.modalRef = this.modalService.open(landinCostModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  // closeModal() {
  //   debugger
  //   this.modalService.dismissAll();
  // }
  closeModal() {
    
    if (this.modalRef) {
      this.modalRef.close();
    } else {
      this.modalService.dismissAll();
    }
  }

  save() {
  
    if (this.form.invalid) {

    } else {
      this.modalService.dismissAll();
    }
  }
  saveCustomer() {
   
    if (this.form.invalid) {

    } else {
      this.modalService.dismissAll();
    }
  }


  showQn2: boolean = false;
  showQn3: boolean = false;
  showQn4: boolean = false;
  showQn5: boolean = false;

  onQn1Change(answer: string) {
    if (answer === 'yes') {
      this.showQn2 = true;
    } else {
      this.resetQuestions();
      this.closeModal();
    }
  }

  onQn2Change(answer: string) {
    if (answer === 'yes') {
      this.showQn3 = true;
    } else {
      this.resetQuestions();
      this.closeModal();
    }
  }

  onQn3Change(answer: string) {
    this.showQn4 = true;
  }

  onQn4Change(answer: string) {
    if (answer === 'no') {
      this.showQn5 = true;
    } else {
      this.resetQuestions();
      this.closeModal();
    }
  }

  resetQuestions() {
    this.showQn2 = false;
    this.showQn3 = false;
    this.showQn4 = false;
    this.showQn5 = false;
  }

  saveLandingCost() {
    
    if (this.form.invalid) {

    } else {
      this.modalService.dismissAll();
    }
  }

  dragNdropIncor(event: any) {
    
    this.incorUploadFiles = [];
    this.selectedIncorFile = event.target.files;
    for (var i = 0; i < this.selectedIncorFile.length; i++) {
      if (this.selectedIncorFile[i]) {
        const file = this.selectedIncorFile[i];
        var reader = new FileReader();
        reader.onload = (event: any) => {
          var str = event.target.result;
          // var name = file.name;
          var name = file.name.split('.').slice(0, -1).join('.');
          var type = file.type;
          var size = file.size;
          var exe = file.name.split('.').pop();
          // var strExe = file.substr(file.lastIndexOf('.') + 1);
          // var splitField = str.replace(/^data:image\/[a-z]+;base64,/, "");
          // console.log('Convert',str);
          var splitField = str
            .replace('data:', '')
            .replace(/^.+,/, '');

          let allFiles = {
            fileName: name,
            fileExtension: exe,
            // Type: type,
            // Size: size,         
            fileByte: splitField
          }
          this.incorUploadFiles.push(allFiles);
          // this.form.patchValue({
          //   tin_file_name: file.name
          //   // trnCertificate: splitField,
          //   // trnCertificateExtension: file.name.split('.').pop()
          // });
          let temp = this.form.get('source_file_name').value;
          if (temp == "") {
            this.form.get('source_file_name').patchValue(file.name);
          } else {
            this.form.get('source_file_name').patchValue(temp + ', ' + file.name);
          }
        }
        reader.readAsDataURL(this.selectedIncorFile[i]);
      }
    }
    console.log('uploaded Files', this.incorUploadFiles)
  }


  uploadSourcingList(uploadFileModal) {
    this.modalRef = this.modalService.open(uploadFileModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  uploadSourcingListFiles(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const wsname2: string = wb.SheetNames[1];
      const ws2: XLSX.WorkSheet = wb.Sheets[wsname2];

      this.data = XLSX.utils.sheet_to_json(ws);
      let customObjFromExcel = XLSX.utils.sheet_to_json(ws2);
      this.dataProp = Object.getOwnPropertyNames(this.data[0]);

      // Remove "__rowNum__" property if it exists
      for (var j = 0; j < this.dataProp.length; j++) {
        if (this.dataProp[j] == "__rowNum__") {
          this.dataProp.splice(j, 1);
        }
      }
      this.sourceListData = [];

      // Set the file name in the variable
      this.sourcingListFileName = target.files[0].name;
      console.log(this.sourcingListFileName); // Display file name in console

      this.form.get('sourcingListFileName').setValue(this.sourcingListFileName); // Optionally update form control

      console.log(this.data);
      for (let i = 0; i < this.data.length; i++) {
        let obj = {
          SlNo: this.data[i]['Sl no'],
          customerPartNumber: String(this.data[i]['Customer Part No.']).trim(),
          internalPartNo: String(this.data[i]['Internal Part No.']).trim(),
          description: String(this.data[i]['Description']).trim(),
          specification: String(this.data[i]['Specification']).trim(),
          commodity: String(this.data[i]['Commodity']).trim(),
          manufacturer: String(this.data[i]['Manufacturer(Mfg)']).trim(),
          uom: String(this.data[i]['UOM']).trim(),
          projectQty: Number(this.data[i]['Project qty']),
          iSourcing: String(this.data[i]['I Sourcing']).trim(),
        };
        this.sourceListData.push(obj);
        if (this.avdData.length === 0) {
          this.finalDataList = this.sourceListData;
        }
        console.log('sourceListData', this.sourceListData);
      }
    };
  }

  // Function to clear the file name
  clearSourcingListFiles() {
    this.sourcingListFileName = '';
    this.form.get('sourcingListFileName').setValue('');
    this.upload_input.value = ''; // Clear the input field
  }
 

  uploadAvdFiles(event: any) {
    this.finalDataList = [];
    this.avdData = [];

    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);

    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const wsname2: string = wb.SheetNames[1];
      const ws2: XLSX.WorkSheet = wb.Sheets[wsname2];

      this.data = XLSX.utils.sheet_to_json(ws);
      let customObjFromExcel = XLSX.utils.sheet_to_json(ws2);
      this.dataProp = Object.getOwnPropertyNames(this.data[0]);

      // Remove "__rowNum__" property if it exists
      for (let j = 0; j < this.dataProp.length; j++) {
        if (this.dataProp[j] == "__rowNum__") {
          this.dataProp.splice(j, 1);
        }
      }

      // Set the file name in the form control
      // Set the file name in the variable
      this.avdListFileName = target.files[0].name;
      console.log(this.avdListFileName); // Display file name in console

      this.form.get('alternatePartFileName').setValue(this.avdListFileName); // Optionally update form control
      // this.form.get('alternatePartFileName').patchValue(target.files[0].name);

      // Process the file data and populate avdData
      for (let i = 0; i < this.data.length; i++) {
        let obj = {
          internalPartNo: String(this.data[i]['Internal Part No.']).trim(),
          manufacturer: String(this.data[i]['Manufacturer(Mfg)']).trim(),
          specification: String(this.data[i]['Specification']).trim(),
        };
        this.avdData.push(obj);
        console.log('avdData', this.avdData);
      }
    };
  }

  // Function to clear the file name
  clearAvdFiles() {
    this.avdListFileName = '';
    this.form.get('alternatePartFileName').setValue('');
    this.upload_avd_input.value = ''; // Clear the input field
  }

  finalData() {
  
    this.finalDataList = [];

    // Combine avdData with matching sourceListData
    for (const avdItem of this.avdData) {
      const matchingSourceItems = this.sourceListData.filter(
        (sourceItem) => String(sourceItem.internalPartNo).trim() === String(avdItem.internalPartNo).trim()
      );

      if (matchingSourceItems.length > 0) {
        for (const sourceItem of matchingSourceItems) {
          const combinedRow = {
            ...avdItem, // Include all properties from avdData
            customerPartNumber: sourceItem.customerPartNumber,
            description: sourceItem.description,
            commodity: sourceItem.commodity,
            uom: sourceItem.uom,
            projectQty: parseFloat(sourceItem.projectQty).toFixed(2),
            iSourcing: sourceItem.iSourcing,
            // manufacturer: sourceItem.manufacturer,
            // specification: sourceItem.specification,
          };
          this.finalDataList.push(combinedRow);
        }
      }
    }
    this.processFinalData();
    console.log('Before Filtered Final Data List:', this.finalDataList);
  }


  processFinalData() {
    
    const uniqueDataMap = new Map<string, any>();

    for (const data of this.finalDataList) {
      // Normalize key without ignoring special characters
      const normalizeString = (value: string | number): string => {
        if (typeof value !== 'string') return String(value).trim();
        return value.trim(); // Keep all characters, including special characters
      };

      // Create a key with special characters intact
      const key = `${normalizeString(data.internalPartNo)}::${normalizeString(data.manufacturer)}::${normalizeString(data.specification)}::${Number(data.projectQty)}`;

      if (!uniqueDataMap.has(key)) {
        uniqueDataMap.set(key, data); // Add unique rows
      }
    }

    // Convert the map back to a list
    this.finalDataList = Array.from(uniqueDataMap.values());

    console.log('Filtered Final Data List:', this.finalDataList);

    // Notify the user if duplicates were removed
    const originalLength = this.sourceListData.length + this.avdData.length;
    if (this.finalDataList.length < originalLength) {
      console.log('Duplicate rows have been removed.');
    }

    setTimeout(() => {
      this.sourceListData = [];
      this.avdData = [];
      this.closeModal();
    }, 1000);
  }

  uploadFinalData() {
    alert("Data uploaded Sucessfully...");
    console.log(this.finalDataList);
    this.finalDataList = [];
  }


  onProjectNameClicked() {
    this.router.navigate(['/project-view']);
  }

  home() {
    this.router.navigate(['/dashboard-engineer'])
  }

}